import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import tablecss from "./../../css/table.module.css";
import bookclosuretaskscss from "./../../css/bookclosuretasks.module.css";
import Modal from "./../../elements/Modal";
import ToggleButton from "./../../elements/ToggleButton";
import { Button, TableButton } from "./../../elements/Button";
import Dropdown from "./../../elements/Dropdown";
import InputGroup from "./../../elements/InputGroup";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";
import { ReactComponent as RoundedCheckIcon } from "../../assets/icons/rounded_check.svg";
import { ReactComponent as AttachmentIcon } from "../../assets/icons/attachment.svg";
import { ReactComponent as PrimaryPlusIcon } from "../../assets/icons/primary_plus.svg";

const AddTaskModal = ({ handleClose, setAddTaskModal, setAddNewTaskModal }) => {
  const th_data = [
    { header: "DATE", accessor: "date" },
    { header: "LEDGER CODE", accessor: "ledger_code" },
    { header: "LEDGER NAME", accessor: "ledger_name" },
    { header: "AMOUNT", accessor: "ampunt" },
    { header: "REMARKS", accessor: "remarks" },
  ];

  return (
    <Modal
      title="Tasks"
      width="80%"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <>
          <div className={commoncss.dFlex}>
            <ToggleButton
              label={"Confidential"}
              // isActive={status}
              onToggle={() => {}}
            />&ensp;
            <CloseIcon
              onClick={() => {
                handleClose();
                setAddTaskModal(false);
                setAddNewTaskModal(false);
              }}
              className="clickable"
            />
          </div>
        </>
      }
      footerActions={
        <>
          <span></span>
          <Button
            btnColor={buttoncss.primary}
            label="Save"
            onClick={() => {
              handleClose();
              setAddTaskModal(false);
              setAddNewTaskModal(false);
            }}
          />
        </>
      }
      onClose={() => console.log("Modal Closed")}
    >
      <div class={`${commoncss.pdlr15} ${bookclosuretaskscss.taskContainer}`}>
        <div
          class={`${commoncss.pdlr15}  ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerLeft}`}
        >
          <InputGroup
            label="Task Name"
            inputs={[
              <>
                <input
                  type="text"
                  onChange={(value) => console.log("value:", value)}
                />
              </>,
            ]}
          />
          <Dropdown
            label="Module Name"
            options={[{ label: "", value: "" }]}
            onSelect={(value) => console.log("Selected:", value)}
            placeHolder={"Select Module"}
          />
          <InputGroup
            label="Task Description"
            inputs={[
              <>
                <textarea
                  value={""}
                  onChange={(value) => console.log("value:", value)}
                  rows={4}
                />
              </>,
            ]}
          />
          <Dropdown
            label="Assignee"
            options={[{ label: "", value: "" }]}
            onSelect={(value) => console.log("Selected:", value)}
            placeHolder={"Select Assignee"}
          />

          <InputGroup
            inputs={[
              <>
                <Dropdown
                  label="Approver"
                  options={[{ label: "", value: "" }]}
                  onSelect={(value) => console.log("Selected:", value)}
                  placeHolder={"Select Approver"}
                />
              </>,
              <>
                <InputGroup
                  label="Due Date"
                  inputs={[
                    <>
                      <input type="date" />
                      <span className="icon">
                        <CalenderIcon
                          className="vaMiddle"
                          width={20}
                          height={20}
                        />
                      </span>
                    </>,
                  ]}
                />
              </>,
            ]}
          />

          <Dropdown
            label="Tag Linked Ledgers"
            options={[{ label: "", value: "" }]}
            onSelect={(value) => console.log("Selected:", value)}
            placeHolder={"Select Ledgers"}
          />
          <InputGroup
            label="Comments"
            inputs={[
              <>
                <input type="text" placeholder="Add Comment" />
                <span className="icon">
                  <RoundedCheckIcon
                    className="vaMiddle"
                    width={20}
                    height={20}
                  />
                </span>
              </>,
            ]}
          />
        </div>
        <div
          class={`${commoncss.pdlr15} ${commoncss.m_tb_20} ${bookclosuretaskscss.taskContainerRight}`}
        >
          <InputGroup
            label="Workings & Remarks"
            icon={<AttachmentIcon className={commoncss.vaMiddle} width={18} />}
            iconLabel="Attach files"
            inputs={[
              <>
                <textarea
                  value={""}
                  placeholder="Type Something..."
                  onChange={(value) => console.log("value:", value)}
                  rows={10}
                />
              </>,
            ]}
          />
          <div className={tablecss.tableContainer}>
            <table className={`${tablecss.customTable} ${tablecss.taskTable}`}>
              <thead>
                <tr>
                  {th_data.map((col, i) => (
                    <th key={i}>{col.header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[].map((row, i) => (
                  <tr key={i}>
                    {th_data.map((col, j) => (
                      <td key={j}>{row[col.accessor]}</td>
                    ))}
                  </tr>
                ))}
                <tr>
                  <td colSpan={th_data.length} style={{ textAlign: "center" }}>
                    <TableButton
                      btnColor={buttoncss.secondary}
                      label="Add Adjustment"
                      icon={<PrimaryPlusIcon />}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddTaskModal;
